(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    var value = Math.round(cents) / 100;
    var match = (format || '${{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function group(n, decimals, thousands, point) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(point);
    }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = group(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = group(value, 2, "'", '.'); break;
      default: out = group(value, 2, ',', '.');
    }
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* Gallery: swap in a fresh <img> so mobile Safari always repaints */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = g.querySelector('[data-gallery-main]');
        if (!main) return;
        var img = main.cloneNode(false);
        img.removeAttribute('srcset');
        img.removeAttribute('fetchpriority');
        img.src = btn.dataset.src;
        img.srcset = btn.dataset.srcset;
        img.alt = btn.dataset.alt;
        main.replaceWith(img);
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Bundles + add to cart */
  document.querySelectorAll('[data-buy]').forEach(function (form) {
    var fmt = form.dataset.moneyFormat;
    var unitPrice = Number(form.dataset.unitPrice);
    var qtyInput = form.querySelector('[data-qty]');
    var defaultVariant = form.querySelector('[data-default-variant]');
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="tier"]'));
    var units = Array.prototype.slice.call(form.querySelectorAll('[data-unit]'));
    var msg = form.querySelector('[data-msg]');
    var btn = form.querySelector('button[type="submit"]');

    function selectedQty() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? Number(r.value) : 1;
    }
    function priceFor(n) {
      var sum = 0;
      for (var i = 0; i < n; i++) {
        var sel = units[i] && units[i].querySelector('select');
        sum += sel ? Number(sel.options[sel.selectedIndex].dataset.price) : unitPrice;
      }
      return sum;
    }
    function update() {
      if (radios.length && !radios.some(function (r) { return r.checked; })) radios[0].checked = true;
      var n = selectedQty();
      qtyInput.value = n;
      units.forEach(function (u, i) { u.hidden = i >= n; });
      if (units[0]) defaultVariant.value = units[0].querySelector('select').value;
      radios.forEach(function (r) {
        var label = r.closest('.tier');
        var base = priceFor(Number(r.value));
        var total = Math.round(base * (100 - Number(r.dataset.discount || 0)) / 100);
        var t = label.querySelector('[data-tier-total]');
        var b = label.querySelector('[data-tier-base]');
        var s = label.querySelector('[data-tier-save]');
        if (t) t.textContent = formatMoney(total, fmt);
        if (b) b.textContent = formatMoney(base, fmt);
        if (s) s.textContent = 'Save ' + formatMoney(base - total, fmt);
      });
    }
    var gallery = form.closest('.pdp') && form.closest('.pdp').querySelector('[data-gallery]');
    function showImage(n) {
      if (!gallery || !n) return;
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      var thumb = thumbs[n - 1];
      if (!thumb) return;
      thumb.click();
      var row = thumb.parentElement;
      row.scrollTo({ left: thumb.offsetLeft - row.offsetLeft - 8, behavior: 'smooth' });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        update();
        showImage(Number(r.dataset.image || 0));
      });
    });
    units.forEach(function (u) { u.querySelector('select').addEventListener('change', update); });
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = selectedQty();
      var counts = {};
      if (units.length) {
        for (var i = 0; i < n; i++) {
          var id = units[i].querySelector('select').value;
          counts[id] = (counts[id] || 0) + 1;
        }
      } else {
        counts[defaultVariant.value] = n;
      }
      var picked = radios.filter(function (x) { return x.checked; })[0];
      var props = null;
      if (picked && n > 1 && picked.dataset.imageUrl) {
        props = { _bundle: picked.dataset.name || '', _bundle_qty: String(n), _image: picked.dataset.imageUrl };
      }
      var items = Object.keys(counts).map(function (id) {
        var line = { id: Number(id), quantity: counts[id] };
        if (props) line.properties = props;
        return line;
      });
      btn.disabled = true;
      msg.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (err) {
          msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Try again.';
          btn.disabled = false;
        });
    });
  });

  /* Delivery estimate */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    function addBusinessDays(n) {
      var d = new Date();
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) n--;
      }
      return d;
    }
    var opts = { weekday: 'short', month: 'short', day: 'numeric' };
    var from = addBusinessDays(Number(el.dataset.min)).toLocaleDateString('en-US', opts);
    var to = addBusinessDays(Number(el.dataset.max)).toLocaleDateString('en-US', opts);
    var text = el.querySelector('[data-delivery-text]');
    if (text) text.textContent = (el.dataset.prefix ? el.dataset.prefix + ' ' : '') + 'Get it between ' + from + ' and ' + to + '.';
  });
  /* Sale countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = Date.parse(el.dataset.end);
    if (isNaN(end)) { el.hidden = true; return; }
    var f = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer;
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      f.d.textContent = pad(Math.floor(left / 86400));
      f.h.textContent = pad(Math.floor((left % 86400) / 3600));
      f.m.textContent = pad(Math.floor((left % 3600) / 60));
      f.s.textContent = pad(left % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  });
  /* Cookie banner (Shopify Customer Privacy API).
     The choice is also remembered in localStorage, so the banner never
     comes back on the next page even if Shopify's consent call is slow. */
  var ck = document.querySelector('[data-cookie]');
  var CK_KEY = 'sg_cookie_choice';
  function readChoice() { try { return localStorage.getItem(CK_KEY); } catch (e) { return null; } }
  function saveChoice(v) { try { localStorage.setItem(CK_KEY, v); } catch (e) {} }
  function sendConsent(cp, yes) {
    try {
      cp.setTrackingConsent(
        { analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes },
        function (err) { if (err) console.warn('Consent not saved', err); }
      );
    } catch (e) { console.warn('Consent not saved', e); }
  }
  if (ck && window.Shopify && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      var cp = window.Shopify.customerPrivacy;
      if (!cp) return;
      var saved = readChoice();
      var current = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      var recorded = current && current.marketing !== '' && current.marketing !== undefined;

      if (saved) {
        /* Visitor already chose. Re-send it if Shopify lost it, and never show the banner. */
        if (!recorded) sendConsent(cp, saved === 'yes');
        return;
      }
      if (recorded || !cp.shouldShowBanner()) return;

      ck.hidden = false;
      ck.querySelectorAll('[data-consent]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var yes = btn.dataset.consent === 'yes';
          saveChoice(yes ? 'yes' : 'no');
          sendConsent(cp, yes);
          ck.hidden = true;
        });
      });
    });
  }
})();